fragment FormStubFragment on Form {
    id
    publicFormId
    name
    htmlUrlPath
    createdTime
    lastUpdatedTime
    canArchive
    numSubmissions
    numLocations
    spamPreventionType
    lastSubmittedTime
    pageVisits
    conversionRate
    isArchived
    createRules {
        lead {
            stageset {
                id
                name
            }
        }
    }
}
